import styled from 'styled-components';

export const Content = styled.div`
  .penalty-title {
    font-size: 15px;
    color: ${(props) => props.theme.$dark};
  }

  .badge {
    white-space: nowrap;
  }
`;
